export default function LocationsSection() {
  const locations = [
    {
      name: "IDS佐賀教習所",
      company: "株式会社アイテム",
      area: "佐賀県全域・福岡県筑後地区",
      address: "佐賀県多久市北多久町大字小侍4771",
      phone: "0952-71-9855",
      email: "saga@ids-group.jp",
      features: [
        "水稲・麦・大豆の散布代行",
        "ドローン運搬サービス",
        "中山間地域対応",
        "急なご依頼にも対応"
      ],
      detailPath: "/saga-contract-spraying",
      image: "https://public.readdy.ai/ai/img_res/72566e9a62b6142ea1a97bc1ca96ff4b.jpg"
    },
    {
      name: "IDS川副教習所", 
      company: "九三エンジニアリング株式会社",
      area: "佐賀県佐賀市周辺",
      address: "佐賀県佐賀市川副町小々森146-1",
      phone: "0952-97-5291",
      email: "kawasoe@ids-group.jp",
      features: [
        "水稲・麦・大豆の散布代行",
        "野菜・果樹対応",
        "測量サービス",
        "地域密着サポート"
      ],
      detailPath: "#",
      image: "https://readdy.ai/api/search-image?query=Agricultural%20training%20facility%20in%20Kawasoe%20Saga%2C%20modern%20building%20with%20agricultural%20drone%20equipment%2C%20professional%20farming%20education%20center%2C%20green%20agricultural%20fields%20surrounding%2C%20clean%20industrial%20design&width=500&height=300&seq=kawasoe-location&orientation=landscape"
    },
    {
      name: "IDS鹿児島教習所",
      company: "株式会社エコナーセリー", 
      area: "鹿児島県全域",
      address: "鹿児島県日置市伊集院町古城795",
      phone: "099-213-9466",
      email: "kagoshima@ids-group.jp",
      features: [
        "水稲・麦・大豆の散布代行",
        "遮熱・遮光剤塗布",
        "果樹園対応",
        "南九州エリアカバー"
      ],
      detailPath: "#",
      image: "https://readdy.ai/api/search-image?query=Agricultural%20facility%20in%20Kagoshima%20prefecture%20Japan%2C%20modern%20training%20center%20building%2C%20subtropical%20agricultural%20landscape%2C%20professional%20drone%20services%20building%2C%20volcanic%20soil%20farming%20region%20background&width=500&height=300&seq=kagoshima-location&orientation=landscape"
    }
  ];

  const handleNavigation = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <section className="py-20 bg-gray-50" data-locations-section>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            対応エリア・拠点一覧
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            佐賀県・福岡県筑後地区・鹿児島県に拠点を構え、広範囲をカバー。<br />
            各拠点で地域に根差したサービスを提供しています。
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {locations.map((location, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={location.image}
                alt={location.name}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{location.name}</h3>
                  <p className="text-sm text-gray-600">{location.company}</p>
                </div>

                <div className="mb-4">
                  <div className="flex items-center text-[#4CAF50] font-semibold mb-2">
                    <i className="ri-map-pin-line mr-2"></i>
                    対応エリア
                  </div>
                  <p className="text-gray-700 font-medium">{location.area}</p>
                </div>

                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">主なサービス</h4>
                  <ul className="space-y-1">
                    {location.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-[#4CAF50] mr-2 flex-shrink-0"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mb-6 space-y-2 text-sm text-gray-600">
                  <div className="flex items-center">
                    <i className="ri-map-pin-2-line mr-2 text-gray-400"></i>
                    {location.address}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-phone-line mr-2 text-gray-400"></i>
                    <a href={`tel:${location.phone}`} className="hover:text-[#4CAF50] transition-colors cursor-pointer">
                      {location.phone}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-2 text-gray-400"></i>
                    <a href={`mailto:${location.email}`} className="hover:text-[#4CAF50] transition-colors cursor-pointer">
                      {location.email}
                    </a>
                  </div>
                </div>

                <button 
                  onClick={() => handleNavigation(location.detailPath)}
                  className="w-full px-4 py-3 bg-[#4CAF50] text-white rounded-lg hover:bg-[#45a049] transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  詳細を見る
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            対応エリア外でもご相談ください。可能な限り対応いたします。
          </p>
          <button 
            className="px-8 py-4 bg-[#4CAF50] text-white rounded-lg hover:bg-[#45a049] transition-colors font-semibold text-lg whitespace-nowrap cursor-pointer"
            onClick={() => {
              const contactSection = document.querySelector('[data-contact-section]');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            まずはお気軽にご相談ください
          </button>
        </div>
      </div>
    </section>
  );
}